module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }